/*
  Hero slider autoplay (sections/hero-slider.liquid).

  UIkit's own autoplay runs a fixed setInterval and just skips ticks while
  hovered, so after a hover the next slide lands at an arbitrary point and a
  CSS progress bar drifts out of sync. Instead one rAF timer here owns both:
  it writes the progress (0..1) to --p for the water-fill bar and calls
  show('next') when it reaches 1. Any slide change (dots, arrows, swipe)
  restarts the timer; hovering the banner image or holding it pauses it.
*/
(() => {
  const init = (root) => {
    if (root.heroAutoplay || !window.UIkit) return;
    const interval = Number(root.dataset.autoplay);
    const stage = root.querySelector('.hero-slider-stage');
    if (!interval || !stage) return;

    const slider = UIkit.slider(root);
    let elapsed = 0;
    let last = performance.now();
    let hovered = false;
    let held = false;

    const paint = () => root.style.setProperty('--p', Math.min(elapsed / interval, 1).toFixed(4));

    // UIkit fires itemshow on the incoming slide without bubbling; capture catches it here.
    root.addEventListener('itemshow', () => { elapsed = 0; paint(); }, true);

    stage.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hovered = true; });
    stage.addEventListener('pointerleave', () => { hovered = false; });
    stage.addEventListener('pointerdown', () => { held = true; });
    const release = () => { held = false; };
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);

    const tick = (now) => {
      if (!root.isConnected) return;
      // Clamp so a backgrounded tab (rAF stops) doesn't jump straight to the next slide.
      const dt = Math.min(now - last, 100);
      last = now;
      if (!hovered && !held) {
        elapsed += dt;
        if (elapsed >= interval) {
          elapsed = 0;
          slider.show('next');
        }
        paint();
      }
      requestAnimationFrame(tick);
    };

    root.heroAutoplay = true;
    requestAnimationFrame(tick);
  };

  const initAll = (scope = document) =>
    scope.querySelectorAll('.hero-slider-wrapper[data-autoplay]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
